// AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { GetDahsboard } from "./api/get";
import Loader from "./loader";
export const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Assume logged out initially
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [willCompleted, setwillCompleted] = useState(null);
  const [willStatus, setWillStatus] = useState(null);

  const [loading, setLoading] = useState(true);
  const login = () => setIsAuthenticated(true);
  const logout = () => setIsAuthenticated(false);

  useEffect(() => {
    // Call both APIs concurrently
    Promise.all([GetDahsboard()])
      .then(([dashboardRes]) => {
        setPaymentStatus(dashboardRes.data?.payment_status); // Set Dashboard Data
        setwillCompleted(dashboardRes.data?.will_completed);
        setWillStatus(dashboardRes.data?.willStatus);
        setLoading(false); // Hide loader when both APIs are done
      })
      .catch((err) => {
        console.log("Error fetching data:", err);
        setLoading(false); // Hide loader even if one API fails
      });
  }, []);


  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <AuthContext.Provider
            value={{ isAuthenticated, login, logout, paymentStatus ,willCompleted,willStatus}}
          >
            {children}
          </AuthContext.Provider>
        </>
      )}
    </>
  );
};

export const useAuth = () => useContext(AuthContext);
